import React from 'react';
import IconProps from '../../icons';

const MightyLogo = ({ width = 100, color = 'var(--text-primary)', className = '' }: IconProps): JSX.Element => {
  return (
    <svg
      className={className}
      width={width}
      viewBox='0 0 104 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-cy='header-logo'
    >
      <path
        d='M0 24.5618H5.28237V16.1689C5.28237 13.0893 6.42169 12.1756 8.11343 12.1756C9.73612 12.1756 10.5647 13.0893 10.5647 15.3567V24.5618H15.8816V16.1689C15.8816 13.0893 17.021 12.1756 18.6782 12.1756C20.3009 12.1756 21.164 13.1231 21.164 15.3906V24.5618H26.4809V14.443C26.4809 11.0249 25.3416 7.80989 20.5771 7.80989C18.1258 7.80989 16.1578 9.06206 15.2602 10.8219C14.5351 9.0959 13.016 7.80989 10.0469 7.80989C7.73366 7.80989 6.0074 8.99438 5.28237 10.6188V8.24984H0V24.5618Z'
        fill={color}
      />
      <path
        d='M31.2317 7.13613C33.1306 7.13613 34.5116 5.71475 34.5116 3.98879C34.5116 2.22899 33.1306 0.807617 31.2317 0.807617C29.3328 0.807617 27.9863 2.22899 27.9863 3.98879C27.9863 5.71475 29.3328 7.13613 31.2317 7.13613ZM28.6078 24.5618H33.8556V8.86516H28.6078V24.5618Z'
        fill={color}
      />
      <path
        d='M48.5925 8.24984V10.585C47.7639 8.89285 45.7269 7.80989 43.4482 7.80989C38.6492 7.80989 35.4729 11.431 35.4729 16.2366C35.4729 21.0422 38.4421 24.5618 43.3792 24.5618C45.5543 24.5618 47.7639 23.5466 48.5925 21.9221V24.088C48.5925 26.9985 47.1079 28.0476 44.6566 28.0476C42.516 28.0476 41.3767 27.2692 41.135 25.9832H35.7491C35.8181 27.743 37.0265 29.5028 38.7183 30.5181C40.3409 31.4657 42.3434 31.8379 44.7257 31.8379C47.1079 31.8379 49.1449 31.4318 50.664 30.3827C52.701 28.9952 53.8403 26.6601 53.8749 23.5127V8.24984H48.5925ZM44.8292 20.5684C42.447 20.5684 40.8933 18.7748 40.8933 16.3043C40.8933 13.8338 42.447 12.0402 44.8292 12.0402C47.3496 12.0402 48.8342 13.9353 48.8342 16.3043C48.8342 18.6733 47.3496 20.5684 44.8292 20.5684Z'
        fill={color}
      />
      <path
        d='M66.6971 7.80989C64.1767 7.80989 62.2779 8.79132 61.3112 10.6188V0.872224H56.0288V24.5618H61.3112V16.0336C61.3112 13.5292 62.416 12.1756 64.522 12.1756C66.6626 12.1756 67.4567 13.4277 67.4567 16.1689V24.5618H72.7736V14.4768C72.7736 10.0435 70.7365 7.80989 66.6971 7.80989Z'
        fill={color}
      />
      <path
        d='M82.5108 20.5346C81.1989 20.5346 80.1976 20.1623 80.1976 17.7595V12.3448H84.3407V8.24984H80.1976V3.4104H74.9153V18.8425C74.9153 24.2911 78.3333 24.8326 80.8191 24.8326C82.7152 24.8326 84.8117 24.3311 85.9887 23.9588C85.9887 23.9588 85.3716 22.8051 85.1362 22.1898C84.9008 21.5745 84.5763 20.4208 84.5763 20.4208C84.0929 20.4884 83.0978 20.5346 82.5108 20.5346Z'
        fill={color}
      />
      <path
        d='M97.6878 8.24984V16.3382C97.6878 18.8425 96.6175 20.4669 94.477 20.4669C92.2673 20.4669 91.5423 19.0455 91.5423 16.9473V8.24984H86.2599V17.7257C86.2599 21.7868 88.1588 24.5618 92.4054 24.5618C94.9258 24.5618 96.7556 23.5804 97.6878 21.8544V24.3926C97.6878 26.9308 96.4104 28.0476 94.477 28.0476C92.4745 28.0476 91.6804 27.2354 91.5768 25.8478H86.2599C86.2945 27.6076 87.1231 29.1305 88.3315 30.1458C89.7125 31.2626 91.6459 31.8379 94.477 31.8379C97.2735 31.8379 99.1033 31.1949 100.588 29.9427C102.003 28.6906 102.97 26.6939 102.97 24.0542V8.24984H97.6878Z'
        fill={color}
      />
    </svg>
  );
};

export default MightyLogo;
